// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { actionStatusSelector } from './actionStatus';
import { useSelector } from 'react-redux';
import { OutputSelector } from 'reselect';

export function useStatusAndDataSelector(
    selector: OutputSelector<any, any, (res: any) => any>,
    actionName: string
) {
    const loadingState = useSelector(state =>
        actionStatusSelector(state)(actionName)
    );
    const selectedData = useSelector(state => selector(state));

    return { loadingState, selectedData };
}
